import { getCourseFolderResources, getCourseResources as apiGetCourseResources } from "../api";
import { courseResourcesPageSize as pageSize } from "../constants";
import config from "../config";

export async function getCourseResources(
    folderId,
    useGenericResourceColumn,
    isResource,
    pageIndex,
    planResources
) {
    let returnedResources = [];
    let totalCount = 0;

    const resConfig = planResources ? planResources : config;

    let elementType = undefined;
    let learningToolType = undefined;

    if (!useGenericResourceColumn) {
        elementType = isResource ? resConfig.elementTypeResources : resConfig.elementTypeActivities;
        learningToolType = isResource
            ? resConfig.learningToolTypeResources
            : resConfig.learningToolTypeActivities;
    }

    if (folderId) {
        const result = await getCourseFolderResources(
            folderId,
            elementType,
            learningToolType,
            pageIndex,
            pageSize
        );

        returnedResources = result.Resources.EntityArray;
        totalCount = result.Resources.Total;
    } else {
        const result = await apiGetCourseResources(
            elementType,
            learningToolType,
            pageIndex,
            pageSize
        );

        returnedResources = result.Resources.EntityArray;
        totalCount = result.Resources.Total;
    }

    const resources = returnedResources.map(r => ({
        id: r.ElementId,
        active: r.Active,
        parentId: folderId,
        title: r.Title,
        type: r.ElementType,
        iconUrl: r.BrandIconUrl || r.IconUrl,
        // The activities resource picker shows folders but they should not be selectable
        disabled: !useGenericResourceColumn && !isResource && r.ElementType === "Folder"
    }));

    return { totalCount, resources };
}
